module.exports = __webpack_public_path__ + "img/rank1.fbc213c7.png";